module.exports = __webpack_public_path__ + "img/10ablue.4c287ccf.png";